export enum TipoUsuarioEnum{
  admin,
  gestorAdmin,
  advogadoGestor,
  assistenteJuridico,
  cliente
}
